export const STUDENT_QUIZ = `/quiz/student/:id(\\d+)?`
export const STUDENT_QUIZ_RESULT = `/quiz/student/result/:id(\\d+)?`
